export default __webpack_public_path__ + "static/phone-80dae6123654d4fe553ec0589e41942d.png";